module.exports = __webpack_public_path__ + "img/icon-rt-consumption.728ebc32.svg";